<link rel="stylesheet" href='https://assets.bambatravel.com/content/css/ContentPagesStyles.css'>


<div class="container mt-5 mb-5">
  <div class="row" [innerHTML]="contentPage?.content | sanitizeHtml"></div>
</div>
